const defaultSettings = {
  canSeeBulletinSearch: true,
  colorCurves: {},
  language: "en",
  mobilePref: "desktop",
  isMobile: {
    phone: false
  }
};

export { defaultSettings };
